import React, { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts";
import { toast } from "react-toastify";
import { CustomTag, CustomPageHeader } from "../../../ui";
import toastOptions from "../../../assets/constants/toast";
import { CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import { ArrowUpRightIcon, DownloadSimpleIcon, TrashIcon, UserIcon } from "@phosphor-icons/react";

const TestView = () => {
    const [test, setTest] = useState(null);
    const [user, setUser] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const { token } = useContext(AuthContext);
    const { testId, userId } = useParams();
    const navigate = useNavigate();

    React.useEffect(() => {
        axios
            .get(process.env.REACT_APP_UPA_API_HOST + "tests/" + testId + "/" + userId, { headers: { Authorization: "Bearer " + token } })
            .then((response) => {
                if (response.data) {
                    console.log(response.data);
                    setTest(response.data.test);
                    setUser(response.data);
                    setIsLoaded(true);
                } else {
                    toast.error("Candidat inconnu", toastOptions);
                    navigate(-1);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, [navigate, token, testId, userId]);

    const handleDelete = () => {
        if (window.confirm("Attention : toutes les données de ce candidat seront perdues.")) {
            axios
                .delete(process.env.REACT_APP_UPA_API_HOST + "tests/" + testId + "/" + user.id, { headers: { Authorization: "Bearer " + token } })
                .then(() => {
                    toast.success("Candidat supprimé", toastOptions);
                    navigate(-1);
                })
                .catch((err) => {
                    toast.error(err.response.data.message, toastOptions);
                });
        }
    };

    return isLoaded ? (
        <div className="c-app__view">
            <CustomPageHeader
                title={`${user.firstName} ${user.lastName.toUpperCase()}`}
                titleIcon={{ icon: UserIcon }}
                buttons={[
                    {
                        label: "Supprimer",
                        onClick: handleDelete,
                        icon: TrashIcon,
                        variant: "cancel",
                    },
                    {
                        label: "Page du candidat",
                        onClick: () => window.open(process.env.REACT_APP_UPA_INTERFACE_HOST + "tests/" + test.id + "/" + user.id, "_blank"),
                        icon: ArrowUpRightIcon,
                        variant: "primary",
                    },
                ]}
            />
            <div className="input-row-container">
                <span className="input-label statut">Nom du test :</span>
                <CustomTag value={test.name} />
            </div>
            <div className="input-row-container">
                <span className="input-label email-gray">Email :</span>
                <CustomTag value={user.email} />
            </div>
            <div className="input-row-container">
                <span className="input-label calendar-gray">Inscription au test :</span>
                <CustomTag value={dayjs(user.createdAt).format("DD MMMM YYYY à HH:mm")} />
            </div>
            <div className="input-row-container">
                <span className="input-label hourglass-gray">Passage du test :</span>
                <CustomTag value={dayjs(user.startDate).format("DD MMMM")} />
                <span className="margin-right margin-left">de</span>
                <CustomTag value={dayjs(user.startDate).format("HH:mm")} />
                <span className="margin-right margin-left">à</span>
                <CustomTag value={dayjs(user.stopDate).format("HH:mm")} />
            </div>
            <div className="input-row-container">
                <span className="input-label file-gray">Dépôt de fichier :</span>
                {user.submittedAt ? (
                    <>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem",
                            }}
                        >
                            <CustomTag value={"Déposé à " + dayjs(user.submittedAt).format("HH:mm")} className="success" />
                            <a href={process.env.REACT_APP_UPA_API_HOST + "tests-uploads/" + user.id + ".zip"} className="download-test">
                                <DownloadSimpleIcon size={16} weight="bold" />
                            </a>
                        </div>
                    </>
                ) : (
                    <CustomTag className="failed" value={"Aucun fichier déposé"} />
                )}
            </div>
        </div>
    ) : (
        <div className="loader-container absolute">
            <CircularProgress size={20} className="white-loader" />
        </div>
    );
};

export default TestView;
